import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button, Drawer } from "@/ui-kit";
import { Form } from "@/components/controls";
import { FormProvider } from "react-hook-form";
import { ServiceAreasForm } from "./ServiceAreasForm";
import { useServiceAreasForm } from "./useServiceAreasForm";
import type { IServiceArea } from "@/types/common";

type IServiceAreasEditModalProps = {
  userId: number;
  serviceAreas: IServiceArea[];
  updateServiceArea: (params: {
    userId: number;
    serviceAreas: IServiceArea[];
  }) => Promise<{ serviceAreas: IServiceArea[] }>;
  onSave: (v: IServiceArea[]) => void;
  onDismiss: () => void;
};

export const ServiceAreasEditModal = ({
  userId,
  serviceAreas,
  updateServiceArea,
  onSave,
  onDismiss,
}: IServiceAreasEditModalProps) => {
  const { t } = useTranslation();

  const handleSuccess = useCallback(
    (response: typeof serviceAreas) => {
      onSave(response);
      onDismiss();
    },
    [onSave, onDismiss],
  );

  const { form, onSubmit, loading } = useServiceAreasForm({
    userId,
    serviceAreas,
    updateServiceArea,
    onSuccess: handleSuccess,
  });

  return (
    <FormProvider {...form}>
      <Drawer
        className="settings__user-modal"
        title={t("label.service_areas")}
        open={true}
        onOpenChange={onDismiss}
        closeOnOutsidePress={false}
        footer={
          <>
            <Button onClick={onDismiss} variant="ghost" color="layer1">
              {t("action.cancel")}
            </Button>
            <Button onClick={onSubmit} loading={loading}>
              {t("action.save")}
            </Button>
          </>
        }
      >
        <Form>
          <ServiceAreasForm color="layer1" />
        </Form>
      </Drawer>
    </FormProvider>
  );
};
